<template>
  <div style="height: 100vh; width: 100%">
    <div class="header">
      <div class="title">喜礼门店管理系统 1.0</div>
      <div class="title2">
        尊敬的{{ this.$store.state.supUser.supplier_phone }}用户，欢迎您！
      </div>
      <div class="tuichuBtn" @click="tuichuBtn">
        <el-tooltip
          class="item"
          effect="dark"
          content="退出登陆"
          placement="bottom"
        >
          <el-button>
            <i class="el-icon-setting"></i>
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="dome">
      <!-- 导航栏 -->
      <div class="menu">
        <el-menu
          router
          :default-active="nextMenuActive"
          :unique-opened="true"
          style="width: 250px; border-right: none"
          background-color="#304156"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-submenu
            :index="item.value"
            v-for="(item, index) in filterArr"
            :key="index"
          >
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group
              v-for="(item2, index) in item.nextMenu"
              :key="index"
            >
              <el-menu-item :index="item2.link" @click="nextMenu(item2.link)">
                {{ item2.name }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { loginOut } from "../services/userServices";
export default {
  created() {
    console.log(this.$store.state.supUser.role_id);
    console.log(
      'localStorage.getItem("nextMenuActive")--------',
      localStorage.getItem("nextMenuActive")
    );
    if (localStorage.getItem("nextMenuActive")) {
      this.nextMenuActive = localStorage.getItem("nextMenuActive");
    } else {
      this.nextMenuActive = "/vipCard";
    }
  },
  data() {
    return {
      nextMenuActive: "/vipCard",
      menuArr: [
        {
          id: 1,
          name: "账号管理",
          value: "1",
          role_id: 0,
          icon: "el-icon-wind-power",
          nextMenu: [
            {
              id: 1,
              name: "子账号管理",
              link: "/admin",
            },
          ],
        },
        {
          id: 2,
          name: "小程序配置",
          value: "2",
          role_id: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            {
              id: 1,
              name: "首页配置",
              link: "/banner",
            },
          ],
        },
        /* 小程序卡券核销系统 */
        {
          id: 9,
          name: "小程序卡券核销系统",
          value: "9",
          role_id: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            {
              id: 1,
              name: "(蟹卡)卡券管理",
              link: "/cardCoupon",
            },
            {
              id: 2,
              name: "(蟹卡)运费模版配置",
              link: "/cardCouponAdress",
            },
            {
              id: 3,
              name: "(蟹卡)卡券限制",
              link: "/cardConfig",
            },
            {
              id: 4,
              name: "(商品)卡券管理",
              link: "/cardCouponGoods",
            },
          ],
        },
        {
          id: 10,
          name: "web卡券系统",
          value: "10",
          role_id: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            {
              id: 1,
              name: "页面配置",
              link: "/webCardCouponConfig",
            },
            {
              id: 2,
              name: "数据管理",
              link: "/webCardCoupon",
            },
          ],
        },
        {
          id: 3,
          name: "门店及商品管理",
          value: "3",
          role_id: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            { id: 1, name: "门店所有用户", link: "/user" },
            {
              id: 2,
              name: "门店列表",
              link: "/store",
            },
            {
              id: 3,
              name: "商品分类管理",
              link: "/goodkinds",
            },
            {
              id: 4,
              name: "商品中心",
              link: "/goods",
            },
          ],
        },
        {
          id: 6,
          name: "会员管理",
          value: "6",
          role_id: 1,
          icon: "el-icon-user-solid",
          nextMenu: [
            {
              id: 1,
              name: "会员卡设置",
              link: "/vipConfig",
            },
            {
              id: 2,
              name: "会员列表",
              link: "/vipCard",
            },
            {
              id: 3,
              name: "会员卡交易记录",
              link: "/vipCardRecode",
            },
          ],
        },
        {
          id: 7,
          name: "订单中心",
          value: "7",
          role_id: 1,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 1,
              name: "订单管理",
              link: "/order",
            },
            //  {
            //   id: 2,
            //   name: "出库记录",
            //   link: "/ShareToB",
            // },
            // {
            //   id: 3,
            //   name: "积分兑换审核",
            //   link: "/Tixian",
            // },
          ],
        },
        {
          id: 8,
          name: "分佣管理",
          value: "8",
          role_id: 0,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 1,
              name: "用户金币余额列表",
              link: "/UserMoneyList",
            },
            {
              id: 2,
              name: "金币兑换审核",
              link: "/Tixian",
            },
            {
              id: 3,
              name: "分享记录",
              link: "/ShareToB",
            },
          ],
        },

        {
          id: 5,
          name: "数据面板",
          value: "5",
          role_id: 1,
          icon: "el-icon-user-solid",
          nextMenu: [
            {
              id: 1,
              name: "门店交易数据",
              link: "/DataPanel",
            },
          ],
        },
      ],
    };
  },
  computed: {
    // 导航权限判断
    filterArr() {
      if (this.$store.state.supUser.role_id == 0) {
        return this.menuArr;
      } else {
        return this.menuArr.filter(
          (item) => item.role_id == this.$store.state.supUser.role_id
        );
      }
    },
  },

  methods: {
    tuichuBtn() {
      loginOut().then((resp) => {
        console.log(resp);
        this.$message({
          type: "success",
          message: "已注销登陆!",
        });
        this.$router.push({ name: "Login" });
      });
    },
    nextMenu(link) {
      console.log(link);
      this.nextMenuActive = link;
      localStorage.setItem("nextMenuActive", link);
    },
  },
};
</script>

<style scoped>
.header {
  position: relative;
  height: 60px;
  background: #fff;
  /* display: flex; */
  line-height: 60px;
  outline: 1px solid rgb(230, 230, 230);
  display: flex;
  background-color: #304156;
}
.header > .title {
  margin-left: 20px;
  font-weight: 600;
  /* border:1px solid red; */
  letter-spacing: 3px;
  color: #cacaca;
}
.header > .title2 {
  margin-left: 50px;
  font-weight: 500;
  /* border:1px solid red; */
  letter-spacing: 1px;
  color: #4b70d8;
}
.tuichuBtn {
  position: absolute;
  right: 20px;
}
.dome {
  height: calc(100vh - 60px);
  background: rgba(255, 255, 255, 0.699);
  display: flex;
}
.dome > .menu {
  /* width: 200px; */
  background: #304156;
  /* border: 1px solid red */
  overflow: auto;
  overflow-x: hidden;
}

.el-menu-item.is-active {
  background-color: rgba(27, 36, 51, 0.76) !important;
}
</style>
